module.exports = __webpack_public_path__ + "images/emoji/straight_ruler.2f242cd04c5d23e9bb7b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/straight_ruler.png
// module id = IxvP
// module chunks = 2